var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-2" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _c(
              "el-select",
              {
                attrs: { disabled: _vm.formId != null, filterable: "" },
                on: { change: _vm.changeServicerInfo },
                model: {
                  value: _vm.adjustApplyFormInfo.servicerName,
                  callback: function($$v) {
                    _vm.$set(_vm.adjustApplyFormInfo, "servicerName", $$v)
                  },
                  expression: "adjustApplyFormInfo.servicerName"
                }
              },
              _vm._l(_vm.sharaAccServicerList, function(item) {
                return _c("el-option", {
                  attrs: { label: item.servicerName, value: item.servicerId }
                })
              })
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _c(
              "el-select",
              {
                attrs: { disabled: _vm.formId != null, filterable: "" },
                on: { change: _vm.changeWarehouseInfo },
                model: {
                  value: _vm.adjustApplyFormInfo.warehouseName,
                  callback: function($$v) {
                    _vm.$set(_vm.adjustApplyFormInfo, "warehouseName", $$v)
                  },
                  expression: "adjustApplyFormInfo.warehouseName"
                }
              },
              _vm._l(_vm.sharaAccWarehouseList, function(item) {
                return _c("el-option", {
                  attrs: { label: item.warehouseName, value: item.warehouseId }
                })
              })
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.adjustApplyFormInfo.accPreStkUsage,
                  callback: function($$v) {
                    _vm.$set(_vm.adjustApplyFormInfo, "accPreStkUsage", $$v)
                  },
                  expression: "adjustApplyFormInfo.accPreStkUsage"
                }
              },
              _vm._l(_vm.accPreStkUsages, function(item) {
                return _c("el-radio", { attrs: { label: item.value } }, [
                  _vm._v(_vm._s(item.text))
                ])
              })
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-row" }, [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c(
            "el-checkbox",
            {
              on: { change: _vm.autoApplyChange },
              model: {
                value: _vm.adjustApplyFormInfo.autoApply,
                callback: function($$v) {
                  _vm.$set(_vm.adjustApplyFormInfo, "autoApply", $$v)
                },
                expression: "adjustApplyFormInfo.autoApply"
              }
            },
            [_vm._v("自动申请")]
          ),
          _vm._v(" "),
          _vm.adjustApplyFormInfo.autoApply
            ? _c(
                "span",
                {
                  staticClass: "swb-btn swb-btn-mini ml20",
                  on: { click: _vm.upLoadApplyFiles }
                },
                [_vm._v("申请附件")]
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _c("div", { staticClass: "simple-row" }, [
      _c("div", { staticClass: "left" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small",
            on: {
              click: function($event) {
                _vm.getShareAccStockByWarehouseId()
              }
            }
          },
          [_vm._v("选择配件")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-form",
          {
            ref: "adjustApplyFormInfo",
            attrs: { model: _vm.adjustApplyFormInfo }
          },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.adjustApplyFormInfo.itemList,
                  border: "",
                  "tooltip-effect": "dark"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "accName",
                    label: "配件名称",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.specificFlag
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("个")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(scope.row.accName))])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "130",
                    prop: "catName",
                    label: "分类",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "130",
                    prop: "brandName",
                    label: "品牌",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "130",
                    prop: "modelSpec",
                    label: "规格",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "right", width: "100", label: "申请数量" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "itemList." + scope.$index + ".quantity",
                                rules: {
                                  validator: _vm.inputQuantity,
                                  trigger: "blur"
                                }
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-content-right",
                                attrs: { type: "text" },
                                model: {
                                  value: scope.row.quantity,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "quantity", _vm._n($$v))
                                  },
                                  expression: "scope.row.quantity"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    width: "80",
                    prop: "unit",
                    label: "单位",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "220",
                    label: "申请描述",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "itemList." + scope.$index + ".memo"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-content-right",
                                attrs: { type: "textarea" },
                                model: {
                                  value: scope.row.memo,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "memo", $$v)
                                  },
                                  expression: "scope.row.memo"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "left", width: "80", label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.removeAcc(scope.$index)
                                }
                              }
                            },
                            [_vm._v("移除")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("共享配件调配单信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("服务商")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("调入仓库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("备货用途")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("配件信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b7b5c30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b7b5c30","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shareAcc/AdjustApplyFormSave.vue
// module id = 2815
// module chunks = 0